import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Logo } from '@/components/ui/Logo';

/** Public: a mistyped link should explain the problem before asking anyone to sign in. */
export function NotFoundPage() {
  useEffect(() => {
    const previousTitle = document.title;
    const existingRobots = document.querySelector<HTMLMetaElement>('meta[name="robots"]');
    const robots = existingRobots ?? document.createElement('meta');
    const previousRobots = robots.content;
    robots.name = 'robots';
    robots.content = 'noindex, follow';
    if (!existingRobots) document.head.appendChild(robots);
    document.title = 'Page not found | OverlayQA';
    return () => {
      document.title = previousTitle;
      if (existingRobots) robots.content = previousRobots;
      else robots.remove();
    };
  }, []);

  return (
    <main className="auth-shell flex min-h-screen items-center justify-center px-4 py-8">
      <div className="auth-shell__panel text-center">
        <Link to="/dashboard" aria-label="OverlayQA dashboard" className="inline-flex rounded focus-visible:outline-primary-500">
          <Logo size="lg" />
        </Link>
        <p className="mt-8 text-6xl font-bold tracking-tight text-primary-500">404</p>
        <h1 className="hero-title mt-4">Page not found</h1>
        <p className="mt-3 text-sm leading-relaxed text-gray-600">
          This page doesn’t exist or may have moved. Head back to your dashboard to keep going.
        </p>
        <Link to="/dashboard" className="btn-primary mt-8 w-full"><span className="text-cap-trim">Go to dashboard</span></Link>
        <a href="https://overlayqa.com" className="mt-5 inline-block text-sm font-medium text-primary-600 underline underline-offset-4">
          <span className="text-cap-trim block">Visit OverlayQA</span>
        </a>
      </div>
    </main>
  );
}
